module.exports = __webpack_public_path__ + "89a3515ab59a462f31366909b3e727e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-uplanner.png
// module id = 1556
// module chunks = 0